import axios from 'axios';
import {
  GET_STATIC_PAGE_REQUEST,
  GET_STATIC_PAGE_SUCCESS,
  GET_STATIC_PAGE_FAILURE
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;
const isValidSlug = slug => (/^[a-zA-Z0-9][a-zA-Z0-9-]{0,120}$/).test(slug || '');

export const getStaticPage = slug => async dispatch => {
  if (!isValidSlug(slug)) {
    dispatch({
      type: GET_STATIC_PAGE_FAILURE,
      payload: { ...errorMessage, status: 404, notFound: true },
      slug
    });
    return null;
  }

  try {
    dispatch({
      type: GET_STATIC_PAGE_REQUEST,
      slug
    });

    const res = await axios.get(`${API_GATEWAY}/content/v1/contracts/${encodeURIComponent(slug)}`);
    const payload = res.data && res.data.body ? res.data.body : res.data;

    if (!payload || (res.data && res.data.success === false)) {
      dispatch({
        type: GET_STATIC_PAGE_FAILURE,
        payload: { ...errorMessage, status: 404, notFound: true },
        slug,
        notFound: true
      });
      return null;
    }

    dispatch({
      type: GET_STATIC_PAGE_SUCCESS,
      payload,
      slug
    });

    return payload;
  } catch (e) {
    const status = e.response && e.response.status;
    dispatch({
      type: GET_STATIC_PAGE_FAILURE,
      payload: e.response && e.response.data || errorMessage,
      slug,
      notFound: status === 404
    });
    return null;
  }
};
